module.exports = __webpack_public_path__ + "img/trip-advisor-white.0e1e59d9.svg";